import { ETSY, SHOPIFY } from './channels';

export const CUSTOM_PROPERTY_IDS = {
  [ETSY]: [513, 514],
  [SHOPIFY]: [],
};

export const COMMON_PROPERTY_IDS = {
  [ETSY]: [
    200, // Primary color
    52047899002, // Secondary Color
    504, // Diameter
    501, // Dimensions
    502, // Fabric
    500, // Finish
    503, // Flavor
    505, // Height
    506, // Length
    507, // Material
    508, // Pattern
    509, // Scent
    100, // TeeShirtSize
    510, // Style
    511, // Weight
    512, // Width
    515, // Device
    46803063659, // Holiday
    46803063641, // Occasion
  ],
  [SHOPIFY]: [],
};
